<div id="wrapper" class="container-fluid mb-4" style="padding-top: 5px">
    <router-outlet></router-outlet>
    <div id="footer">&copy; Tecnologia Blue Route</div>
</div>

